<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">View Attachments</h2>
    <mat-icon (click)="closeDialog()" class="close-icon" mat-dialog-close>
      close
    </mat-icon>
    <div contentContainer class="row">
      <div class="">
        <form class="row d-flex">
          <div class="col-md-8 justify-content-start">
            <label class=""><h4 class="label-content body-font-size">Choose file:</h4></label>
            <input [disabled] = "!this.attachmentData.data" class="body-font-size "  multiple (change)="selectFile($event)" [disabled] = "disableAttachmentFileIcon" type="file" name = "file" id = "fileUpload"/>
            <!-- <mat-error [ngStyle]="{'color':'red'}"></mat-error> -->
          </div>
          <div class="col-lg-4 col-sm-12 text-align-end" *ngIf="spinner">
            <div class="meeting-indicator">
              <mat-progress-spinner mode="indeterminate" [diameter]="20"  *ngIf="spinner" bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
          </div>
          </div>
          <div class="col-md-4 justify-content-end text-end" [ngStyle]="{'padding':'10px 10px 0px 0px'}">
            <button [disabled] = "!this.attachmentData.data" mat-raised-button actions (click)="upload(attachmentData.e,attachmentData.m)" class="button-container mar-l-8 primary" [disabled] = "disableAttachmentFileIcon">
              UPLOAD
            </button>
            <button [disabled] = "!this.attachmentData.data" mat-raised-button type="reset" (click)="resetAttachment($event)" actions class="button-container mar-l-8 primary disableAfterApprove" id = "resetbtn">
              RESET
            </button>
          </div>
        </form>
      </div>
    </div>
    <div contentContainer class="row example-accordion-item-body">
      <table mat-table [dataSource]="fileDataSource" class="col-12 mat-elevation-z2 demo-table" matSort>
             
        <!-- file name Column -->
        <ng-container matColumnDef="filename">
          <th mat-header-cell class="header-container" *matHeaderCellDef> File Name </th>
          <td mat-cell *matCellDef="let element" [ngStyle]="{'cursor':'pointer'}" class="body-font-size col-lg-6" (click)="getAttachfile(element.attachmentId,element.attachmentTitle,element.attachmentContentType)"><a >{{element.attachmentTitle}}</a></td>
        </ng-container>
      
        <!-- file type Column -->
        <ng-container matColumnDef="filetype">
          <th mat-header-cell class="header-container" *matHeaderCellDef> File Type </th>
          <td mat-cell *matCellDef="let element" class="body-font-size col-lg-2"> {{element.attachmentContentType}} </td>
        </ng-container>
      
        <!-- size Column -->
        <ng-container matColumnDef="size">
          <th mat-header-cell class="header-container" *matHeaderCellDef> Size(In KB) </th>
          <td mat-cell *matCellDef="let element" class="body-font-size col-lg-2 "> {{element.attachmentContentLength}} </td>
        </ng-container>

        <!-- delete Column -->
        <ng-container matColumnDef="delete">
          <th mat-header-cell class="header-container" *matHeaderCellDef> Delete </th>
          <td mat-cell *matCellDef="let element" class="body-font-size col-lg-2"><button mat-icon-button (click)="this.attachmentData.data ? deleteAttachment(element.attachmentId) : ''" class="icon-bttn " [disabled] = "disableAttachmentFileIcon"><mat-icon class="icon-logo"> delete </mat-icon></button></td>
        </ng-container>
      
        <!-- edit Column -->
        <!-- <ng-container matColumnDef="edit">
          <th mat-header-cell class="header-container" *matHeaderCellDef> Edit </th>
          <td mat-cell *matCellDef="let element"><button mat-icon-button class="icon-bttn"><mat-icon class="icon-logo"> {{element.edit}} </mat-icon></button></td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr [ngClass] = "row.existing ? 'left-border' : '' " mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <div actions>
      <mat-paginator  [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>
    <!-- <button [ngStyle]="{'display':'none'}" mat-raised-button actions class="button-container primary">
        UPLOAD
    </button> -->
    <!-- <button mat-raised-button actions class="button-container" mat-dialog-close>
        CANCEL
    </button>-->
</app-centre-small-opener>
